// src/observability/moduleFromRoute.ts
// Derive a coarse "module" label from the current route's first path segment.
// Duplicated per frontend repo (see ems-api docs/observability/phase-3-frontend-reporter.md).
export function moduleFromRoute(pathname: string | undefined | null): string {
    if (!pathname) {
        return 'unknown';
    }
    const path = pathname.split('?')[0] ?? pathname;
    const segment = path.split('/').filter(Boolean)[0];
    return segment ?? 'unknown';
}
